import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = { class: "text-left px-0" }
const _hoisted_12 = { class: "pl-1 pr-0" }
const _hoisted_13 = { class: "pl-1 pr-0" }
const _hoisted_14 = { class: "pl-1 pr-0" }
const _hoisted_15 = { class: "pl-1 pr-0" }
const _hoisted_16 = { class: "pl-1 pr-0" }
const _hoisted_17 = { class: "pl-1 pr-0" }
const _hoisted_18 = { class: "pl-1 pr-0" }
const _hoisted_19 = { class: "pl-1 pr-0" }
const _hoisted_20 = {
  style: {"text-align":"center"},
  class: "pl-1 pr-0"
}
const _hoisted_21 = { class: "text-left pl-0 pr-0" }
const _hoisted_22 = { class: "pl-1 pr-0" }
const _hoisted_23 = { class: "pl-1 pr-0" }
const _hoisted_24 = { class: "pl-1 pr-0" }
const _hoisted_25 = { class: "pl-1 pr-0" }
const _hoisted_26 = { class: "pl-1 pr-0" }
const _hoisted_27 = { class: "pl-1 pr-0" }
const _hoisted_28 = { class: "pl-1 pr-0" }
const _hoisted_29 = { class: "pl-1 pr-0" }
const _hoisted_30 = { class: "text-center pl-1 pr-0" }
const _hoisted_31 = { class: "pl-1 pr-0" }
const _hoisted_32 = { class: "pl-1 pr-0" }
const _hoisted_33 = {
  style: {"text-align":"center"},
  class: "pl-1 pr-0"
}
const _hoisted_34 = { class: "pl-1 pr-0" }
const _hoisted_35 = { class: "pl-1 pr-0" }
const _hoisted_36 = { class: "text-center pl-1 pr-0" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "body-1 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_btn_add_icon = _resolveComponent("v-btn-add-icon")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_window, {
      modelValue: _ctx.step,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.step) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "priceListTable" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-start pt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "pl-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_primary, {
                      block: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {
                                _ctx.priceList.version = 2;
                                _ctx.editPriceList(null);
                            }),
                      disabled: _ctx.disabledAdd
                    }, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode(" Ajouter une grille tarifaire AGIRIS ")
                      ])),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "pl-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.version,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.version) = $event)),
                      items: _ctx.versions,
                      label: "Version"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-center pt-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: _ctx.listHeaders,
                  items: _ctx.priceListItems,
                  "fixed-header": "",
                  style: {"width":"100%"},
                  "max-height": "60vh",
                  "items-per-page-options": [5, 10, 25, -1],
                  class: "table"
                }, {
                  item: _withCtx((props) => [
                    _createElementVNode("tr", {
                      onClick: ($event: any) => (_ctx.editPriceList(props.item))
                    }, [
                      _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.name), 1),
                      _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.getPriceListType(props.item.type)), 1),
                      _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.getPriceListScope(props.item.scope)), 1),
                      _createElementVNode("td", _hoisted_5, _toDisplayString(props.item.discountPercentage || "-"), 1),
                      _createElementVNode("td", _hoisted_6, _toDisplayString(props.item.discountDuration || "-"), 1),
                      _createElementVNode("td", _hoisted_7, _toDisplayString(props.item.prices.length), 1),
                      _createElementVNode("td", _hoisted_8, [
                        _createTextVNode(_toDisplayString(props.item.accountingFirms.length) + " ", 1),
                        _createVNode(_component_v_btn_icon, {
                          icon: " $fa-user ",
                          color: "secondary",
                          elevation: "0",
                          size: "small",
                          onClick: _withModifiers(($event: any) => (_ctx.showClientDialog(props.item)), ["stop"])
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("td", _hoisted_9, [
                        _createVNode(_component_v_btn_icon, {
                          icon: " $oss-edit ",
                          elevation: "0",
                          size: "x-small"
                        }),
                        _createVNode(_component_v_btn_icon, {
                          icon: "$oss-duplicate",
                          class: "pl-1",
                          elevation: "0",
                          onClick: _withModifiers(($event: any) => (_ctx.editPriceList(props.item, true)), ["stop"]),
                          "data-cy": "PriceList-duplicate",
                          size: "x-small"
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("td", _hoisted_10, [
                        _createVNode(_component_v_switch, {
                          modelValue: props.item.deprecated,
                          "onUpdate:modelValue": ($event: any) => ((props.item.deprecated) = $event),
                          onChange: ($event: any) => (_ctx.modifyDepracated(props.item)),
                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                      ])
                    ], 8, _hoisted_1)
                  ]),
                  _: 1
                }, 8, ["headers", "items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "priceListData" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "d-flex justify-start py-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "5",
                  class: "d-flex align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_back, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.back()))
                    }),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.priceList.name,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.priceList.name) = $event)),
                      class: "pl-2",
                      label: "Nom",
                      required: "",
                      outlined: "",
                      "hide-details": "",
                      block: "",
                      density: "compact"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "3",
                  class: "align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "pl-2"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.priceList.type,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.priceList.type) = $event)),
                              items: _ctx.priceListTypes,
                              label: "Type",
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "",
                              block: "",
                              density: "compact",
                              "item-title": (item) => item.text
                            }, null, 8, ["modelValue", "items", "item-title"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "px-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.priceList.scope,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.priceList.scope) = $event)),
                              items: _ctx.priceListScopes,
                              label: "Perimètre",
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "",
                              block: "",
                              density: "compact",
                              "item-title": (item) => item.text
                            }, null, 8, ["modelValue", "items", "item-title"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "px-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.priceList.discountPercentage,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.priceList.discountPercentage) = $event)),
                              label: "Remise",
                              suffix: "%",
                              required: "",
                              "hide-details": "",
                              dense: "",
                              block: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "px-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.priceList.discountDuration,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.priceList.discountDuration) = $event)),
                              label: "Duration",
                              suffix: "M",
                              required: "",
                              "hide-details": "",
                              dense: "",
                              block: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "4",
                          class: "d-flex align-center justify-end pl-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              rounded: "",
                              elevation: "0",
                              disabled: _ctx.disabledSave,
                              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.upsertPriceList()), ["stop"])),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.priceList.id ? "Modifier" : "Créer"), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.priceList.version === 1)
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0,
                  "no-gutters": "",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      headers: _ctx.headers,
                      items: _ctx.priceList.prices,
                      "items-per-page": -1,
                      style: {"width":"100%"},
                      class: "table"
                    }, {
                      item: _withCtx(({ item, index }) => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.getTitle(item)), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: item.unitPrice,
                              "onUpdate:modelValue": ($event: any) => ((item.unitPrice) = $event),
                              suffix: "€",
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              rules: [
                                            (v) =>
                                                (v !== '' && parseFloat(v) >= 0.0) ||
                                                _ctx.$t('settings.positiveNumber'),
                                        ]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                          ]),
                          _createElementVNode("td", _hoisted_12, [
                            _createVNode(_component_v_switch, {
                              modelValue: item.withVAT,
                              "onUpdate:modelValue": ($event: any) => ((item.withVAT) = $event),
                              "hide-details": "",
                              class: "mt-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_13, [
                            _createVNode(_component_v_select_filled, {
                              modelValue: item.taxSystem,
                              "onUpdate:modelValue": ($event: any) => ((item.taxSystem) = $event),
                              items: _ctx.taxSystems,
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.text
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                          ]),
                          _createElementVNode("td", _hoisted_14, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: item.minAccountingLineCount,
                              "onUpdate:modelValue": ($event: any) => ((item.minAccountingLineCount) = $event),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_15, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: item.maxAccountingLineCount,
                              "onUpdate:modelValue": ($event: any) => ((item.maxAccountingLineCount) = $event),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_16, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: item.discountPercentage,
                              "onUpdate:modelValue": ($event: any) => ((item.discountPercentage) = $event),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              suffix: "%",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_17, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: item.discount,
                              "onUpdate:modelValue": ($event: any) => ((item.discount) = $event),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              suffix: "€",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_18, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: item.minQuantity,
                              "onUpdate:modelValue": ($event: any) => ((item.minQuantity) = $event),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_19, [
                            _createVNode(_component_v_select_filled, {
                              modelValue: item.accountingType,
                              "onUpdate:modelValue": ($event: any) => ((item.accountingType) = $event),
                              items: _ctx.accountingTypes,
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.text
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                          ]),
                          _createElementVNode("td", _hoisted_20, [
                            _createVNode(_component_v_btn_trash, {
                              onClick: ($event: any) => (_ctx.deleteRow(index)),
                              size: "x-small"
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ]),
                      "body.append": _withCtx(() => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.getTitle(_ctx.newPrice)), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.newPrice.unitPrice,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newPrice.unitPrice) = $event)),
                              suffix: "€",
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              rules: [
                                            (v) =>
                                                (v !== '' && parseFloat(v) >= 0.0) ||
                                                _ctx.$t('settings.positiveNumber'),
                                        ]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("td", _hoisted_22, [
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.newPrice.withVAT,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newPrice.withVAT) = $event)),
                              "hide-details": "",
                              class: "mt-0"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_23, [
                            _createVNode(_component_v_select_filled, {
                              modelValue: _ctx.newPrice.taxSystem,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newPrice.taxSystem) = $event)),
                              items: _ctx.taxSystems,
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.text
                            }, null, 8, ["modelValue", "items", "item-title"])
                          ]),
                          _createElementVNode("td", _hoisted_24, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.newPrice.minAccountingLineCount,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newPrice.minAccountingLineCount) = $event)),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_25, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.newPrice.maxAccountingLineCount,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newPrice.maxAccountingLineCount) = $event)),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_26, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.newPrice.discountPercentage,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newPrice.discountPercentage) = $event)),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              suffix: "%",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_27, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.newPrice.discount,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newPrice.discount) = $event)),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              suffix: "€",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_28, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.newPrice.minQuantity,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newPrice.minQuantity) = $event)),
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("td", _hoisted_29, [
                            _createVNode(_component_v_select_filled, {
                              modelValue: _ctx.newPrice.accountingType,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.newPrice.accountingType) = $event)),
                              items: _ctx.accountingTypes,
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.text
                            }, null, 8, ["modelValue", "items", "item-title"])
                          ]),
                          _createElementVNode("td", _hoisted_30, [
                            _createVNode(_component_v_btn_add_icon, {
                              size: "x-small",
                              disabled: _ctx.invalidRow(),
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.addRow()))
                            }, null, 8, ["disabled"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["headers", "items"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  "no-gutters": "",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_data_table, {
                      headers: _ctx.headers,
                      items: _ctx.priceList.prices,
                      "items-per-page": -1,
                      style: {"width":"100%"},
                      class: "table"
                    }, {
                      item: _withCtx(({ item, index }) => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_31, [
                            _createVNode(_component_v_select_filled, {
                              modelValue: item.offer,
                              "onUpdate:modelValue": ($event: any) => ((item.offer) = $event),
                              items: _ctx.offerTypes,
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.text
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: item.unitPrice,
                              "onUpdate:modelValue": ($event: any) => ((item.unitPrice) = $event),
                              suffix: "€",
                              "content-class": "oss-",
                              outlined: "",
                              dense: "",
                              "hide-details": "",
                              rules: [
                                            (v) =>
                                                (v !== '' && parseFloat(v) >= 0.0) ||
                                                _ctx.$t('settings.positiveNumber'),
                                        ]
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"])
                          ]),
                          _createElementVNode("td", _hoisted_33, [
                            _createVNode(_component_v_btn_trash, {
                              onClick: ($event: any) => (_ctx.deleteRow(index)),
                              size: "x-small"
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ]),
                      "body.append": _withCtx(() => [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_34, [
                            _createVNode(_component_v_select_filled, {
                              modelValue: _ctx.newPrice.offer,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.newPrice.offer) = $event)),
                              items: _ctx.offerTypes,
                              "item-value": "value",
                              outlined: "",
                              "hide-details": "",
                              density: "compact",
                              "item-title": (item) => item.text
                            }, null, 8, ["modelValue", "items", "item-title"])
                          ]),
                          _createElementVNode("td", _hoisted_35, [
                            _createVNode(_component_oss_text_field_filled, {
                              modelValue: _ctx.newPrice.unitPrice,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.newPrice.unitPrice) = $event)),
                              suffix: "€",
                              "hide-details": "",
                              rules: [
                                            (v) =>
                                                (v !== '' && parseFloat(v) >= 0.0) ||
                                                _ctx.$t('settings.positiveNumber'),
                                        ]
                            }, null, 8, ["modelValue", "rules"])
                          ]),
                          _createElementVNode("td", _hoisted_36, [
                            _createVNode(_component_v_btn, {
                              fab: "",
                              size: "x-small",
                              color: "primary",
                              disabled: _ctx.invalidRow(),
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.addRow())),
                              elevation: "0",
                              icon: "$add"
                            }, null, 8, ["disabled"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["headers", "items"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.clientListDialog,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.clientListDialog) = $event)),
      title: _ctx.priceListName,
      width: "50vw"
    }, {
      default: _withCtx(() => [
        (_ctx.priceListClients.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "8",
                    class: "justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, {
                        style: {"overflow-y":"auto","max-height":"60vh"},
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceListClients, (client, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              class: "mb-2 px-2",
                              key: index
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                                    _createTextVNode(" $fa-building ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(client.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" SIRET : " + _toDisplayString(client.siret.slice(0, 14)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, " Aucun client n'est associé à cette grille tarifaire "))
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}